import { Flex, styled, Text } from '@shared/components';

import type { LearningObjectiveStatement } from '../../utils';
import { LOSRow, type LOSRowSlots } from '../los-row';

const StyledNoLOSText = styled(Text)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  padding: theme.spacing(0, 0, 0, 13),
  height: '52px',
  alignContent: 'center',
}));

export type LOSListSlots = LOSRowSlots;

export interface LOSListProps {
  data: LearningObjectiveStatement[];
  slots?: LOSListSlots;
}

export default function LOSList(props: Readonly<LOSListProps>) {
  const { data, slots } = props;

  const hasLOS = (data ?? []).length > 0;

  if (!hasLOS) {
    return <StyledNoLOSText color='textSecondary'>ไม่มีข้อมูล LOS</StyledNoLOSText>;
  }

  return (
    <Flex sx={{ flexDirection: 'column' }}>
      {data.map((los, index) => (
        <LOSRow key={los.id} los={los} index={index} total={data.length} slots={slots} />
      ))}
    </Flex>
  );
}
